import { ArrowUpRight, Compass, Sparkles } from "lucide-react";
import { LOGO_URL, WHATSAPP_URL } from "@/data/siteData";

const titleLines = [
  "LUXURY CLEANING.",
  "ISLAND EXCELLENCE.",
  "GUARANTEED.",
];

export default function HeroSection({ onQuote }) {
  return (
    <section className="hero" id="top" data-testid="hero-section">
      <div className="hero__orb hero__orb--one" aria-hidden="true" />
      <div className="hero__orb hero__orb--two" aria-hidden="true" />
      <div className="hero__inner section-shell">
        <div className="hero__copy">
          <div className="eyebrow hero__eyebrow"><span className="eyebrow__dot" /> Sint Maarten / White-glove service</div>
          <h1 className="hero__title" data-testid="hero-headline-title">
            {titleLines.map((line, index) => <span className="hero__title-line" key={line}><span className="hero__title-line-inner" style={{ animationDelay: `${350 + index * 130}ms` }}>{line}</span></span>)}
          </h1>
          <p className="hero__lede">For homes, hotels, businesses, aircraft, yachts, and every environment in between. A more considered way to care for the island.</p>
          <div className="hero__actions">
            <button className="button button--gold" type="button" onClick={() => onQuote()} data-testid="hero-reserve-button">Reserve bespoke service <ArrowUpRight size={17} /></button>
            <a className="button button--line" href={WHATSAPP_URL} target="_blank" rel="noreferrer" data-testid="hero-whatsapp-link"><Sparkles size={16} /> Direct WhatsApp dispatch</a>
          </div>
          <div className="hero__footnote"><Compass size={15} /> Island-wide coverage / discreet arrival / dependable finish</div>
        </div>
        <div className="hero-stage">
          <figure className="hero-photo-frame">
            <img src="https://static.prod-images.emergentagent.com/jobs/1b2417f2-a450-4018-84ad-e16255dbd8d1/images/fb17a9a41627dcbf8a8911511d8013e25146944d14a2c3cf8295f38653dd6e9f.jpeg" alt="Sunlit Caribbean villa living room overlooking the sea" data-testid="hero-service-image" />
            <figcaption>01 / private sanctuary care</figcaption>
          </figure>
          <div className="hero-crest-plate">
            <img src={LOGO_URL} alt="Gold pelican emblem" data-testid="hero-brand-emblem" />
            <div>
              <span className="eyebrow">The island mark</span>
              <h2>Care with a higher point of view.</h2>
              <p>Luxury cleaning. Island excellence. Guaranteed.</p>
            </div>
          </div>
          <div className="hero-stage-meta"><span>SXM</span><span>18° 02′ N / 63° 03′ W</span><span>Est. premier standard</span></div>
        </div>
      </div>
    </section>
  );
}
